import './budgetBreakdown.css';

import { useState, useMemo } from 'react';

import Swatch from '../../../assets/icons/swatch/swatch';
import SpacerBar from '../../spacerBar/spacerBar';

export default function BudgetBreakdown({analyticsTime, organizationData, filteredExpenses, filteredCategories}) {

    const [expenseBar, setExpenseBar] = useState(100);
    const [budgetBar, setbudgetBar] = useState(100);
    const [targetBudget, setTargetBudget] = useState([[0], ['loading']]); 

    const totalAmountExpense = (filteredCategories?.[analyticsTime]?.reduce((sum, current) => sum + current?.expense_amount, 0).toFixed(2));

    const setBudgetBars = useMemo(() => {

        const grandTotal = (filteredCategories?.[analyticsTime]?.reduce((sum, current) => sum + current?.expense_amount, 0)) + organizationData[analyticsTime].budget;
        
        setExpenseBar(((totalAmountExpense / grandTotal) * 100 + 10).toFixed(0));
        setbudgetBar(((organizationData[analyticsTime].budget / grandTotal) * 100 + 10).toFixed(0));

        const currentBars = [[((totalAmountExpense / grandTotal) * 100).toFixed(0)],[((organizationData[analyticsTime].budget / grandTotal) * 100).toFixed(0)]]

        if (currentBars[0] < currentBars[1]) {
            setTargetBudget([[currentBars[1] - currentBars[0]],['Under target budget']])
        } else {
            setTargetBudget([[currentBars[0] - currentBars[1]],['Over target budget']])
        }


    }, [filteredCategories, filteredExpenses, analyticsTime, organizationData]);

    return (
        <div className="budget-breakdown card">
            <div className="budget-breakdown-container">
                <div className="budget-breaksown-header">
                    <p>Budget Breakdoen:</p>
                    <div>
                        <div className="swatch-identifier"><Swatch swatch="var(--budget-color)"/><p>Target Budget</p></div>
                        <div className="swatch-identifier"><Swatch swatch="var(--primary-color)"/><p>Expenses</p></div>
                    </div>
                </div>
                <div className="budget-breakdown-bars">
                    <div className="bar bar-budget" style={{background: 'var(--budget-color)', width: `${budgetBar}%`}}><strong>{`$${organizationData[analyticsTime].budget}`}</strong></div>
                    <div className="bar bar-expenses" style={{background: 'var(--primary-color)', width: `${expenseBar}%`}}><strong>{`$${totalAmountExpense}`}</strong></div>

                </div>
                <SpacerBar width='60%'/>
                <div className="budget-breakdown-content">
                    <strong>{`${targetBudget[0]}%`}</strong><p>{targetBudget[1]}</p>
                </div>
            </div>
        </div>
    )
}